import PropTypes from 'prop-types';

export const contentfulConfigType = PropTypes.exact({
  accessToken: PropTypes.string,
  host: PropTypes.string,
  space: PropTypes.string,
});

export const contentfulType = PropTypes.objectOf(
  PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]).isRequired,
);
